import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const FILTROS_INICIAIS = { usuario: '', de: '', ate: '', metodo: '', q: '' };

const AdminLogs = () => {
  const [filtros, setFiltros] = useState(FILTROS_INICIAIS);
  const [registros, setRegistros] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(50);
  const [carregando, setCarregando] = useState(true);

  const authHeader = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('access')}` },
  });

  const montarParams = useCallback((extra = {}) => {
    const p = new URLSearchParams();
    Object.entries(filtros).forEach(([k, v]) => { if (v) p.append(k, v); });
    p.append('page', extra.page || page);
    p.append('page_size', pageSize);
    return p.toString();
  }, [filtros, page, pageSize]);

  const carregar = useCallback(async (paginaAlvo) => {
    setCarregando(true);
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/audit-log/?${montarParams({ page: paginaAlvo })}`,
        authHeader()
      );
      setRegistros(resp.data.registros || []);
      setTotal(resp.data.total || 0);
    } catch (e) {
      toast.error('Erro ao carregar a trilha de atividades.');
    } finally {
      setCarregando(false);
    }
  }, [montarParams]);

  useEffect(() => {
    carregar(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const aplicarFiltros = () => {
    setPage(1);
    carregar(1);
  };

  const limparFiltros = () => {
    setFiltros(FILTROS_INICIAIS);
    setPage(1);
    setTimeout(() => carregar(1), 0);
  };

  const mudarPagina = (nova) => {
    setPage(nova);
    carregar(nova);
  };

  const exportarCSV = async () => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/audit-log/export/?${montarParams()}`,
        { ...authHeader(), responseType: 'blob' }
      );
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = 'trilha_atividades.csv';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      toast.error('Erro ao exportar CSV.');
    }
  };

  const totalPaginas = Math.max(1, Math.ceil(total / pageSize));

  return (
    <div className="container-fluid py-4">

      <div className="card mb-4">
        <div className="card-header bg-white">
          <h5 className="mb-0" style={{ color: '#212529' }}>
            <i className="fas fa-list-check me-2" style={{ color: '#212529' }}></i>
            Trilha de Atividades
          </h5>
          <small style={{ color: '#6c757d' }}>Ações de escrita registradas por usuário</small>
        </div>
        <div className="card-body">
          <div className="row g-2">
            <div className="col-md-3">
              <input type="text" className="form-control" placeholder="Usuário"
                value={filtros.usuario}
                onChange={(e) => setFiltros((p) => ({ ...p, usuario: e.target.value }))} />
            </div>
            <div className="col-md-2">
              <input type="date" className="form-control" value={filtros.de}
                onChange={(e) => setFiltros((p) => ({ ...p, de: e.target.value }))} />
            </div>
            <div className="col-md-2">
              <input type="date" className="form-control" value={filtros.ate}
                onChange={(e) => setFiltros((p) => ({ ...p, ate: e.target.value }))} />
            </div>
            <div className="col-md-2">
              <select className="form-select" value={filtros.metodo}
                onChange={(e) => setFiltros((p) => ({ ...p, metodo: e.target.value }))}>
                <option value="">Todos métodos</option>
                <option value="POST">POST</option>
                <option value="PUT">PUT</option>
                <option value="PATCH">PATCH</option>
                <option value="DELETE">DELETE</option>
              </select>
            </div>
            <div className="col-md-3">
              <input type="text" className="form-control" placeholder="Buscar ação/rota"
                value={filtros.q}
                onChange={(e) => setFiltros((p) => ({ ...p, q: e.target.value }))} />
            </div>
          </div>
          <div className="mt-3 d-flex gap-2">
            <button className="btn btn-dark" onClick={aplicarFiltros}>Filtrar</button>
            <button className="btn btn-outline-secondary" onClick={limparFiltros}>Limpar</button>
            <button className="btn btn-outline-dark ms-auto" onClick={exportarCSV}>
              <i className="fas fa-file-csv me-2"></i>Exportar CSV
            </button>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          {carregando ? (
            <p style={{ color: '#6c757d' }}><i className="fas fa-spinner fa-spin me-2"></i>Carregando...</p>
          ) : (
            <>
              <div className="table-responsive">
                <table className="table table-sm table-hover align-middle">
                  <thead className="table-dark">
                    <tr>
                      <th>Data/Hora</th>
                      <th>Usuário</th>
                      <th>Ação</th>
                      <th>Método</th>
                      <th>Rota</th>
                      <th>Status</th>
                      <th>IP</th>
                    </tr>
                  </thead>
                  <tbody>
                    {registros.map((r) => (
                      <tr key={r.id}>
                        <td>{r.timestamp_formatted}</td>
                        <td>{r.username || '—'}</td>
                        <td>{r.acao_label}</td>
                        <td><span className="badge bg-secondary">{r.metodo}</span></td>
                        <td><small className="text-muted">{r.rota}</small></td>
                        <td>{r.status_code}</td>
                        <td>{r.ip_address || '—'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {registros.length === 0 && (
                <p className="text-center text-muted my-4">Nenhum registro encontrado.</p>
              )}

              <div className="d-flex justify-content-between align-items-center mt-3">
                <small style={{ color: '#6c757d' }}>
                  {total} registro(s) — página {page} de {totalPaginas}
                </small>
                <div className="btn-group">
                  <button className="btn btn-sm btn-outline-dark" disabled={page <= 1}
                    onClick={() => mudarPagina(page - 1)}>Anterior</button>
                  <button className="btn btn-sm btn-outline-dark" disabled={page >= totalPaginas}
                    onClick={() => mudarPagina(page + 1)}>Próxima</button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminLogs;
